import { CellContext, Loading } from '@shape-ds/components';
import { EventItemColumns } from 'pages/Asset/tabs/Events/hooks/useAlarmCDColumns';
import { EventItem } from 'queries/events/types';
import { useTranslation } from 'react-i18next';
import { severityMap, AgregNumber } from 'components';
import { SeverityPills, buildColumnsObject } from '@shape/lighthouse-components';
import { dateTimeDay, sortDatesDesc } from 'utils/DateUtil';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { EVENT_PAGE } from 'config/paths';
import { darkColors } from '@shape-ds/tokens';

export const getEventsColumns: () => EventItemColumns = () => {
  return {
    severity: {
      size: 60,
      enableSorting: false,
      cell: (row: CellContext<EventItem & { agreg: string }, unknown>) => {
        const severityLevel = row.row.original.severity;

        return <SeverityPills severity={severityMap[severityLevel]} />;
      },
    },

    alarm_datetime_start: {
      size: 80,
      enableSorting: false,
      sortingFn: (a: { original: EventItem }, b: { original: EventItem }) =>
        sortDatesDesc(a.original.alarm_datetime_start, b.original.alarm_datetime_start),
      cell: (row: CellContext<EventItem & { agreg: string }, unknown>) => {
        return dateTimeDay(row.row.original.alarm_datetime_start);
      },
    },

    description: {
      enableSorting: false,
    },

    agreg: {
      size: 42,
      enableSorting: false,
      cell: (row: CellContext<EventItem, unknown>) => (
        <AgregNumber value={row.row.original.children?.length} />
      ),
    },

    // notif: {
    //   size: 30,
    //   enableSorting: false,
    //   cell: (row: CellContext<EventItem, unknown>) => {
    //     return (
    //       <div className="bell-icon">
    //         <FontAwesomeIcon icon={faBell} color={darkColors.GRAY_6} />
    //       </div>
    //     );
    //   },
    // },

    link: {
      size: 30,
      enableSorting: false,
      cell: (row: CellContext<EventItem, unknown>) => {
        return (
          <Link to={EVENT_PAGE(row.row.original.id)} target="_blank" rel="noopener noreferrer">
            <div className="">
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} color={darkColors.GRAY_6} />
            </div>
          </Link>
        );
      },
    },

    // delete: {
    //   size: 30,
    //   enableSorting: false,
    //   cell: (row: CellContext<EventItem, unknown>) => {
    //     return (
    //       <div className="delete-icon" onClick={() => console.log('delete')}>
    //         <FontAwesomeIcon icon={faTrashAlt} color={darkColors.GRAY_6} />
    //       </div>
    //     );
    //   },
    // },
  };
};

export const useRelatedAlarmColumns = () => {
  const { t } = useTranslation();
  const eventsColumns = getEventsColumns();
  return {
    columns: buildColumnsObject<EventItem & { agreg?: string }>({
      columns: eventsColumns,
      getLabel: (key) => t(`case:table.${key}`),
    }),
  };
};
